import React from "react";
import '../../assets/css/NotFound.scss';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../contexts/TranslationContext";

const NotFound = () => {
  const { language } = useTranslation();
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="not-found">
      <div className="not-found-container">
        <div className="error-code">404</div>
        <h1 className="error-title">{language.notFound?.title || "Page Not Found"}</h1>
        <p className="error-description">
          {language.notFound?.description || "The page you are looking for doesn't exist or has been moved."}
        </p>
        <div className="error-actions">
          <button 
            className="btn btn-primary back-to-login"
            onClick={handleBackToLogin}
          >
            <i className="fa fa-sign-in"></i>
            {language.notFound?.backToLogin || "Back to Login"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;